/**
 * Store async deferreds
 * @module
 */
var actionTypes = require('../constants/action_types');

/**
 * @typedef {Object} AsyncInfoSource
 */

module.exports = {
  initialize: function() {
    this.__state = {} as any;

    this.on(actionTypes.REGISTER_ASYNC_DEFERRED, this.__registerDeferred);
    this.on(actionTypes.RESOLVE_DEFERRED, this.__resolveDeferred);
    this.on(actionTypes.REJECT_DEFERRED, this.__rejectDeferred);
  },

  /**
   *
   * @param {AsyncInfoSource} source
   * @returns {Deferred}
   */
  getRequest: function(source:import('core/stores/async_request').AsyncInfoSource): Deferred {
    return this.__state[source];
  },

  /**
   *
   * @param {string} source
   * @returns {Promise|undefined}
   */
  getPromise: function(source:string): Promise<any>|undefined {
    var request = this.getRequest(source);
    if (request) {
      return request.promise;
    }
  },

  /**
   *
   * @param {Object} payload
   * @property {string} payload.source
   * @property {Promise} payload.promise
   * @property {Function} payload.resolver
   * @param {Function} [payload.rejecter]
   * @private
   */
  __registerDeferred: function(payload:any) {
    if (__INVARIANT__) {
      if (this.__state[payload.source]) {
        throw new Error('Overwriting deferred for source: ' + payload.source);
      }
    }

    this.__state[payload.source] = {
      promise: payload.promise,
      resolver: payload.resolver,
      rejecter: payload.rejecter,
    };
  },

  /**
   *
   * @param {Object} payload
   * @param {string} payload.source
   * @param {*} [payload.resolveWith]
   * @private
   */
  __resolveDeferred: function(payload:any) {
    var request = this.getRequest(payload.source);
    if (!request) {
      throw new Error('No request registered for source: ' + payload.source);
    }
    request.resolver(payload.resolveWith);
  },

  /**
   *
   * @param {Object} payload
   * @param {string} payload.source
   * @param {*} [payload.rejectWith]
   * @private
   */
  __rejectDeferred: function(payload:any) {
    var request = this.getRequest(payload.source);
    if (!request) {
      throw new Error('No request registered for source: ' + payload.source);
    }
    if (!request.rejecter) {
      throw new Error('No rejecter registered for source: ' + payload.source);
    }
    request.rejecter(payload.rejectWith);
  },
};
